module.exports = __webpack_public_path__ + "static/img/30.815a931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/30.png
// module id = BPTs
// module chunks = 0